export default "__VITE_ASSET__kgDhftgh__"